module.exports = __webpack_public_path__ + "img/logo-huawei.216cee96.svg";